import React from "react";

interface ServiceSourcesChartProps {
  sopSourceData: any;
  timePeriod: string;
  onTimePeriodChange: (period: string) => void;
}

export const ServiceSourcesChart: React.FC<ServiceSourcesChartProps> = ({
  sopSourceData,
  timePeriod,
  onTimePeriodChange,
}) => {
  const successRates = sopSourceData?.result?.sourcesBreakdown?.map(
    (source, index) => {
      const colors = [
        "bg-orange-500",
        "bg-blue-500",
        "bg-purple-500",
        "bg-green-500",
        "bg-red-500",
      ];
      return {
        name: source.sourceName,
        rate: source.successRate,
        color: colors[index % colors.length],
        totalOrders: source.totalOrders,
        percentageOfTotal: source.percentageOfTotal,
      };
    }
  );

  const totalOrders = sopSourceData?.result?.totalOrders || 0;
  const uniqueSources = sopSourceData?.result?.uniqueSources || 0;
  const overallPercentage = sopSourceData?.result?.overallPercentage || 0;

  return (
    <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden">
      <div className="h-1 " />
      <div className="p-2">
        <div className="mb-2 flex justify-between items-start pb-4">
          <div>
            <h2 className="card-heading-text">
              Service Orders by Source
            </h2>
            <p className="card-subheading-text">
              Analyze service requests by origin channels
            </p>
          </div>

          <select
            value={timePeriod}
            onChange={(e) => onTimePeriodChange(e.target.value)}
            className="px-2 py-1 border w-[50%] border-gray-300 rounded text-xs focus:outline-none focus:ring-2 focus:ring-orange-500 focus:border-transparent bg-white"
          >
            <option value="30">Last 30 days</option>
            <option value="60">Last 60 days</option>
            <option value="90">Last 90 days</option>
          </select>
        </div>

        <div className="grid grid-cols-2 gap-1.5 mb-3">
          <div className="bg-gray-50 rounded-lg p-2 text-center">
            <div className="text-lg font-bold text-gray-900">{totalOrders}</div>
            <div className="text-xs text-gray-500">Total Orders</div>
          </div>
          <div className="bg-green-50 rounded-lg p-2 text-center">
            <div className="text-lg font-bold text-green-600">
              {overallPercentage}%
            </div>
            <div className="text-xs text-green-600">
              From {uniqueSources} Sources
            </div>
          </div>
        </div>

        <div className="mb-3">
          <h3 className="text-xs font-semibold text-gray-700 mb-1.5">
            Success Rate Distribution
          </h3>
          <div className="space-y-1.5">
            {successRates?.map((source, index) => (
              <div key={index}>
                <div className="flex justify-between items-center mb-0.5">
                  <div className="flex flex-col">
                    <span className="text-xs font-medium text-gray-700">
                      {source.name}
                    </span>
                    <span className="text-xs text-gray-500"></span>
                  </div>
                  <span className="text-xs font-semibold text-gray-900">
                    {source.rate}%
                  </span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-1.5">
                  <div
                    className={`h-1.5 rounded-full ${source.color} transition-all duration-500`}
                    style={{ width: `${source.rate}%` }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
